import {DataTable, date} from '@management-ui/core';
import {MTableToolbar} from '@material-table/core';
import moment from 'moment';
import {reverse} from 'named-urls';
import * as React from 'react';
import {useCallback, useContext, useMemo, useRef, useState} from 'react';
import {useHistory} from 'react-router-dom';
import ContactTypes from '../../../../components/ContactTypes';
import Materials from '../../../../components/Materials';
import {ServiceContext} from '../../../../components/Services';
import routes from '../../../../routes';
import Filter from './Filter';

const Table = ({title, type}) => {
  const services = useContext(ServiceContext);
  const history = useHistory();
  const [period, setPeriod] = useState('12');
  /** @type {({current: DataTable})} */
  const tableRef = useRef();

  const goToDetail = useCallback((contact) => {
    history.push(reverse(contact.archived ? routes.archive.contact.detail : routes.contacts.detail, {id: contact.id}));
  }, [history]);

  const handlePeriod = useCallback((changed) => {
    setPeriod(changed);
    if (tableRef.current) {
      tableRef.current.refresh();
    }
  }, []);

  return (
    <DataTable
      ref={tableRef}
      title={title}
      tableProps={{
        components: {
          Toolbar: useCallback((props) => (
            <>
              <MTableToolbar {...props}/>
              <Filter
                period={period}
                onChangePeriod={handlePeriod}
              />
            </>
          ), [period, handlePeriod])
        }
      }}
      columns={useMemo(() => [
        {title: 'Name', field: 'name'},
        {title: 'Customer Code', field: 'customer_code'},
        {title: 'Supplier Code', field: 'supplier_code'},
        {title: 'Types', sorting: false, field: 'types', render: item => <ContactTypes contact={item}/>},
        {
          title: 'Materials',
          sorting: false,
          field: 'materials',
          render: item => <Materials materials={item.materials}/>
        },
        ...(type === 'purchase' ? [
          {
            title: 'Last Purchase Order',
            field: 'last_purchase_order',
            render: item => item.last_purchase_order ? date(item.last_purchase_order) : '-'
          }
        ] : [
          {
            title: 'Last Sales Order',
            field: 'last_sales_order',
            render: item => item.last_sales_order ? date(item.last_sales_order) : '-'
          }
        ])
      ], [type])}
      loadData={useCallback(query => new Promise((resolve, reject) => {

        const params = {};
        params[type === 'purchase' ? 'noPurchases' : 'noSales'] = moment().subtract(period, 'months').format('YYYY-MM-DD');
        params[type === 'purchase' ? 'suppliers' : 'customers'] = '1';
        services.contact.getTableContacts(query, params)
          .then(response => {
            resolve({
              data: response.data, page: response.meta.current_page - 1, totalCount: response.meta.total
            });
          }).catch(() => reject());
      }), [services, period, type])}
      onRowClick={goToDetail}
    />
  );
};

export default Table;
